export default "__VITE_ASSET__717289b4__"